import React, { useEffect, useState } from 'react';

import Icon from 'components/icon'

import { LayerType } from '../types/accordion.type'

import classesBuilder from 'shared/utils/classesBuilder'
import UseLayer from './hooks/useLayer'

import * as style from 'theme/components/accordion/accordion.module.scss'

const Layer: React.FC<LayerType> = ({
  body,
  full,
  title,
  height,
  expanded,
  handleChange,
  accordionItem,
  disabled,
  children,
  cellSpacing,
  handleExpanded,
  overflowVisibleWhenOpen,
}) => {
  const [ overflowVisible, setOverflowVisible ] = useState(overflowVisibleWhenOpen ? false : expanded)
  const [ autoHeight, setAutoHeight ] = useState(height ? false : expanded)
  const { getAccordionContent, useAccordion, useAccordionHeight, setAccordion } = UseLayer(
    !!expanded,
  )

  let timeoutAutoHeight = 0;
  const handleAccordionChange = (): void => {
    setAutoHeight(false)

    window.setTimeout(() => {
      setAccordion(!useAccordion)
      handleChange?.(accordionItem)
      handleExpanded?.(!useAccordion)
    }, 0);

    if (height) {
      return
    }

    window.clearTimeout(timeoutAutoHeight)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    timeoutAutoHeight = window.setTimeout(() => {
      setAutoHeight(!useAccordion)
    }, 250);
  }

  const classNames = {
    layer: true,
    full,
    open: useAccordion,
    disabled,
    cellSpacing,
    overflowVisible,
  }

  const accordionElement = body || children

  let timeoutOverflow = 0;
  useEffect(() => {
    if (!overflowVisibleWhenOpen) {
      return;
    }

    if (!useAccordion) {
      setOverflowVisible(false)
      return;
    }

    window.clearTimeout(timeoutOverflow)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    timeoutOverflow = window.setTimeout(() => {
      setOverflowVisible(true)
    }, 250);
  }, [useAccordion]);

  return (
    <div className={classesBuilder(style, classNames)}>
      <div className={classesBuilder(style, { title: true })} {...(!disabled && { onClick: () => handleAccordionChange() })}>
        <div className={classesBuilder(style, { label: true })}>{title}</div>
        <span className={classesBuilder(style, { icon: true })}>
          <Icon name="arrow-ios-downward-outline" />
        </span>
      </div>

      <div
        style={{ maxHeight: autoHeight ? 'none' : `${useAccordionHeight}px` }}
        className={classesBuilder(style, { body: true })}
        ref={getAccordionContent}
      >
        <div style={{ maxHeight: autoHeight ? 'none' : `${height}px` }} className={classesBuilder(style, { content: true })}>
          {accordionElement}
        </div>
      </div>
    </div>
  )
}

export default Layer
